// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const supportedLanguages = [
    { code: 'en', name: 'EN' },
    { code: 'zh-CN', name: '简中' }, // Simplified Chinese
    { code: 'ms', name: 'B.M.' },
    { code: 'th', name: 'ภาษาไทย' },
];

// This list is for i18next internal logic, including what the LanguageDetector can match against.
// We add 'zh' here if 'zh-CN' is a primary supported Chinese variant.
// This allows 'zh' (generic Chinese) to be detected and then fall back to 'zh-CN' resources.
const i18nextSupportedLngs = [...supportedLanguages.map(lang => lang.code)];
if (i18nextSupportedLngs.includes('zh-CN') && !i18nextSupportedLngs.includes('zh')) {
    i18nextSupportedLngs.push('zh');
}



i18n
    .use(HttpBackend) // Loads translations from your server/public folder
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        // Fallback strategy:
        // If 'zh' is detected (and it's in i18nextSupportedLngs), and /locales/zh/translation.json is missing,
        // i18next will try to load 'zh-CN' resources based on this configuration.
        // The 'default' array is the ultimate fallback for any language not otherwise specified.
        fallbackLng: {
            'zh': ['zh-CN', 'en'], // For generic 'zh', try 'zh-CN', then 'en'
            // You could add other specific fallbacks if needed, e.g.:
            // 'zh-HK': ['zh-CN', 'en'],
            // 'zh-TW': ['zh-CN', 'en'],
            'default': ['en']       // Default fallback for all other languages
        },
        debug: window.APP_CONFIG.NODE_ENV === 'development', // Enable debug output in development
        supportedLngs: i18nextSupportedLngs, // Use the expanded list for i18next's internal checks
        interpolation: {
            escapeValue: false, // React already safes from xss
        },
        backend: {
            // Adjust loadPath to be relative to the public URL
            loadPath: `${window.APP_CONFIG.PUBLIC_URL || ''}/locales/{{lng}}/{{ns}}.json?v=1.0.250613`,
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage'],
            // This ensures that i18next checks if the detected language is in `supportedLngs`.
            // Since 'zh' will now be in `i18nextSupportedLngs`, it won't be rejected outright by the detector.
            // checkWhitelist is deprecated and not needed in recent i18next versions.
        },
        react: {
            useSuspense: true, // Recommended for loading translations
        }
    });

export default i18n;